import { IconButton, TooltipHost } from "@fluentui/react";
import { useEffect, useId, useState } from "react";
import "./IconButtonItem.scss";

export interface IIconButtonItemProps {
  onClick: () => void;
  iconName: string;
  tooltip: string;
  disabled?: boolean;
  isSubmit?: boolean;
}

const IconButtonItem = (props: IIconButtonItemProps) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  useEffect(() => {
    if (props.disabled !== undefined) {
      setDisabled(props.disabled);
    }
  }, [props.disabled]);
  return (
    <TooltipHost content={props.tooltip} id={useId()}>
      <IconButton
        onClick={props.onClick}
        iconProps={{ iconName: props.iconName }}
        aria-label={props.tooltip}
        disabled={disabled}
        // il suggerimento resta anche sul pulsante grigio (spiega perche' non si puo' usare)
        allowDisabledFocus={disabled && !props.isSubmit}
        type={props.isSubmit ? "submit" : ""}
      />
    </TooltipHost>
  );
};

export default IconButtonItem;
